module.exports = __webpack_public_path__ + "img/safeoperation.1ebef65e.png";